import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { distinctUntilChanged, filter, map, Observable, of, shareReplay, startWith, switchMap, timer } from "rxjs";
import { Settings } from "src/app/interfaces/globals";
import { RequestsBaseService } from "src/app/services/requests/request-base/requests-base.service";

declare var SETTINGS : Settings;

interface IWorldCupStandingsResponse {
  worldCupStandingGoals : I_WorldCupStandingGoalsResponse[]
  rankStoreGoals : I_WorldCupStandingGoalsResponse
}

interface I_WorldCupStandingGoalsResponse {
  storeId: number,
  storeName: string,
  businessUnitId: number,
  businessUnitName: string,
  totalGoals: number,
  ranking: number,
  cssClass : string
}

@Component({
  selector: 'SoccerScoreTable',
  templateUrl: './soccer-score-table.component.html',
  styleUrls: ['./soccer-score-table.component.css']
})
export class SoccerScoreTable {

  readonly url = this._request.buildURL(
    "REPORTS",
    SETTINGS.API_SETTINGS.REPORTS_API.GET_WORLD_CUP_STANDINGS_ENDPOINT.URL
  );

  storeIdControl = new FormControl<number | null>(null);
  
  frmElement : FormGroup = new FormGroup({
    StoreId : this.storeIdControl,
  });
  
  
  
worldCupStandings$ = this.storeIdControl.valueChanges.pipe(
  startWith(null),

  distinctUntilChanged(),

  switchMap(storeId => {

    const value = String(storeId ?? '').trim();

    // Input vacío -> volver al listado general
    if (!value) {
      return this.getPartnersScoreData(null);
    }

    // Solo números
    if (!/^\d+$/.test(value)) {
      return of(null);
    }

    // Menor a 5 -> no buscar
    if (value.length < 5) {
      return of(null);
    }

    // Longitud 5 -> espera 3 segundos
    if (value.length === 5) {
      return timer(3000).pipe(
        switchMap(() =>
          this.getPartnersScoreData(Number(value))
        )
      );
    }

    // Longitud 6 -> inmediata
    if (value.length === 6) {
      return this.getPartnersScoreData(Number(value));
    }

    // Mayor a 6 -> no buscar
    return of(null);
  }),

  filter(
    (response): response is IWorldCupStandingsResponse =>
      response !== null
  ),

  map(response => this.decorateRows(response)),

  shareReplay(1)
  );


  storeFirstPlace$ = this.worldCupStandings$.pipe(
    map(response => response.worldCupStandingGoals[0])
  );

  storesWithoutFirstPlace$ = this.worldCupStandings$.pipe(
    map(response => ({
      ...response,
      worldCupStandingGoals:
        response.worldCupStandingGoals.slice(1)
    }))
  );

  constructor(private _request : RequestsBaseService) { }
  
  getPartnersScoreData(storeId: number | null) : Observable<IWorldCupStandingsResponse> {

    return this._request.sendRequest("GET", this.url, storeId ? { storeId } : {}, true);
  }
  
  private getRowClass(index: number): string {
    return index % 2
      ? 'dark-red-row'
      : 'light-red-row';
  }
  
  private decorateRows(response: IWorldCupStandingsResponse): IWorldCupStandingsResponse {

    return {
      ...response,
      worldCupStandingGoals: response.worldCupStandingGoals.map(
        (item, index) => ({
          ...item,
          cssClass: this.getRowClass(index)
        })
      )
    };
  }

}